import { experimentsWrapper } from '../sdk/experimentsWrapper';
import { resizeMediaUrlWithWatermark as resizeMediaUrlWithWatermarkOld, resizeMediaUrl as resizeMediaUrlOld } from './itemResizerOld';
import { resizeMediaUrlWithWatermark as resizeMediaUrlWithWatermarkNew, resizeMediaUrl as resizeMediaUrlNew } from './itemResizerNew';
export var resizeMediaUrl = function resizeMediaUrl() {
  var useNew = experimentsWrapper.getExperimentBoolean('specs.pro-gallery.useMultipleImageUrls');
  return useNew ? resizeMediaUrlNew.apply(void 0, arguments) : resizeMediaUrlOld.apply(void 0, arguments);
};
export var resizeMediaUrlWithWatermark = function resizeMediaUrlWithWatermark() {
  var useNew = experimentsWrapper.getExperimentBoolean('specs.pro-gallery.useMultipleImageUrls');
  return useNew ? resizeMediaUrlWithWatermarkNew.apply(void 0, arguments) : resizeMediaUrlWithWatermarkOld.apply(void 0, arguments);
};